// assets
import { IconBuildingStore, IconChartBar, IconFileText, IconMail, IconNotes, IconUsers, IconUsersGroup } from '@tabler/icons-react';

import { DESIGN_SYSTEM_COMPONENTS, DesignSystemComponent } from '../constant/designSystem';
import { NavItemType } from '../types';

// constant
const icons = {
    IconUsers,
    IconChartBar,
    IconBuildingStore,
    IconUsersGroup,
    IconNotes,
    IconMail,
    IconFileText
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

type OtherMenuOptions = {
    hideWeekendHandoff?: boolean;
    showMeetingView?: boolean;
    showSupervisorScorecard?: boolean;
    showInsights?: boolean;
    showDartReport?: boolean;
    showStaticSubscribers?: boolean;
    showMeetingTranscription?: boolean;
    isSilverStay?: boolean;
};

export const getOtherMenu = ({
    hideWeekendHandoff = false,
    showMeetingView = false,
    showInsights = false,
    showSupervisorScorecard = false,
    showDartReport = false,
    showStaticSubscribers = false,
    showMeetingTranscription = false,
    isSilverStay = false
}: OtherMenuOptions = {}): NavItemType => ({
    id: 'staff-nav-items',
    icon: IconUsers,
    type: 'group',
    children: [
        {
            id: 'handoff',
            title: 'Handoff',
            type: 'item',
            url: '/dashboard',
            icon: icons.IconChartBar,
            breadcrumbs: false
        },
        ...(showInsights
            ? [
                  {
                      id: 'Insights',
                      title: 'Insights',
                      type: 'item',
                      url: '/insights',
                      icon: icons.IconChartBar,
                      breadcrumbs: false
                  }
              ]
            : []),
        {
            id: 'patients',
            title: 'Patients',
            type: 'item',
            url: '/patients',
            icon: icons.IconUsers,
            breadcrumbs: false
        },
        {
            id: 'census',
            title: 'Census',
            type: 'item',
            url: '/census',
            icon: icons.IconChartBar,
            breadcrumbs: false
        },
        ...(showDartReport
            ? [
                  {
                      id: 'dart-report',
                      title: 'DARt',
                      caption: 'Discharge Acceleration Report',
                      type: 'item',
                      url: '/dart-report',
                      icon: icons.IconChartBar,
                      breadcrumbs: false
                  }
              ]
            : []),
        ...(isSilverStay
            ? [
                  {
                      id: 'my-patients',
                      title: 'CCM',
                      caption: 'Complex Case Management',
                      type: 'item',
                      url: '/my-patients',
                      icon: icons.IconNotes,
                      breadcrumbs: false
                  }
              ]
            : []),
        ...(showStaticSubscribers
            ? [
                  {
                      id: 'static-subscribers',
                      title: 'Static Subscribers',
                      type: 'item',
                      url: '/static-subscribers',
                      icon: icons.IconMail,
                      breadcrumbs: false
                  }
              ]
            : []),
        ...(showMeetingView
            ? [
                  {
                      id: 'meeting-view',
                      title: 'Meeting View',
                      type: 'item',
                      url: '/meeting-view',
                      icon: icons.IconUsersGroup,
                      breadcrumbs: false
                  }
              ]
            : []),
        ...(showMeetingTranscription
            ? [
                  {
                      id: 'meeting-transcription',
                      title: 'Meeting Transcription',
                      type: 'item',
                      url: '/meeting-transcription',
                      icon: icons.IconFileText,
                      breadcrumbs: false
                  }
              ]
            : []),
        ...(showSupervisorScorecard
            ? [
                  {
                      id: 'supervisor-scorecard',
                      title: 'Performance Scorecard',
                      type: 'item',
                      url: '/supervisor/scorecard',
                      icon: icons.IconUsersGroup,
                      breadcrumbs: false
                  }
              ]
            : []),

        ...(import.meta.env.DEV
            ? [
                  {
                      id: 'design-system',
                      title: 'Design System',
                      type: 'collapse',
                      icon: icons.IconChartBar,
                      children: DESIGN_SYSTEM_COMPONENTS.map((component: DesignSystemComponent) => ({
                          id: `design-system-${component.id}`,
                          title: component.title,
                          type: 'item',
                          url: component.path,
                          breadcrumbs: true
                      }))
                  }
              ]
            : [])
    ].filter((item) => !hideWeekendHandoff || item.id !== 'handoff')
});

const other: NavItemType = getOtherMenu();

export default other;
